import * as React from 'react';
import ReactTable from 'react-table';
import CustomPagination from '../../sys/pagination';
import { Button, Input, Label, Modal, Table, Form, Dropdown } from 'semantic-ui-react';

interface Props {

}
interface State {
    data: any;
    showManualModal: boolean;
    ssid: any;
    mac: any;
    username: string;
    password: string;
    authentication: any;
}
export default class WifiConfigView extends React.Component<Props, State> {
    protected columns = [{
        width: 25
    }, {
        Header: 'SSID',
     //   accessor: 'status.name',
        width: 280,
     //   Cell: (props: any) => this.statusNameRenderer(props)
    }, {
        Header: 'MAC',
    //    accessor: 'statistics.general.startTime',
        width: 180,
    //    Cell: (props: any) => Renderers.timestamp.format(props.value)
    }, {
        Header: 'Channel',
    //    accessor: 'statistics.general.cycleTimeStart',
        width: 90,
        align: 'right',
    //    Cell: (props: any) => this.NARenderer(props.value)
    }, {
        Header: 'Frequency',
    //    accessor: 'statistics.general.age',
        width: 130,
        align: 'right',
    //    Cell: (props: any) => this.activeSecRenderer(props.value)
    }, {
        Header: (h: any) => <span>Signal<br/>Strength</span>,
    //    accessor: 'statistics.veristream.toatls',
        width: 90,
        align: 'right',
    //    Cell: (props: any) => this.totalVSRenderer(props)
    }, {
        Header: 'Rate',
    //    accessor: 'statistics.fifteen.general.erroredSecs',
        width: 90,
        align: 'right',
    //    Cell: (props: any) => this.availabilityRenderer(props)
    }, {
        Header: 'Authentication',
    //    accessor: 'statistics.timing.dvst',
        width: 120,
        align: 'right',
    //    Cell: (props: any) => Renderers.secToMsec(props.value),

    }];

    componentWillMount() {
        this.setState({
            showManualModal: false,
            ssid: '',
            mac: '',
            username: '',
            password: '',
            authentication: ''
        });
    }

    // tslint:disable-next-line:no-empty
    fetchData() {

    }
    handleManualModalClose() {
        this.setState({
            showManualModal: false
        });
    }
    currentConnection() {
        return (
            <div className="stream-stats-panel">
                <Table className="very basic table margin-top-bottom">
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    Status:
                                </Label>
                            </Table.Cell>
                            <Table.Cell >
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    SSID:
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    Address:
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    MAC:
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell rowspan="2">
                                <Button
                                    className="filterPanel-secondary-btn"
                                    content="Disconnect"
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    Strength:
                                </Label>
                            </Table.Cell>
                            <Table.Cell >
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    Frequency:
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    Authentication:
                                </Label>
                            </Table.Cell>
                            <Table.Cell>
                                <Label className="filterPanelLabel">
                                    -
                                </Label>
                            </Table.Cell>
                            <Table.Cell />

                            <Table.Cell />
                        </Table.Row>
                    </Table.Body>
                </Table>

            </div>
        );
            }

    render() {

        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const authenticationOptions = [
            { value: 'none', text: 'None'},
            { value: 'PSK', text: 'PSK'},
            { value: '802.1X', text: '802.1X'}
        ];
        return (
            <div className="view-content" id="streamStats">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Wi-Fi</div>
                        </div>
                    </div>
                    <Button className="rightButton" content="Rescan Networks" />
                    <Button className="rightButton" content="Manual Connect" onClick={() => this.setState({showManualModal: true})}/>
                </div>
                {this.currentConnection()}
                <div className="view-clientarea">
                    <ReactTable
                        className="transaction-log -striped -highlight"
                        onFetchData={() => this.fetchData()}
                        data={(this.state && this.state.data) ? this.state.data : []}
                        columns={this.columns}
                        defaultPageSize={16}
                        PaginationComponent={CustomPagination}
                    />
                    <Modal
                        open={this.state.showManualModal}
                        onClose={() => this.handleManualModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>Manual Connect</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    <Label className="filterPanelLabel">
                                        SSID:
                                    </Label>
                                    <Input
                                        value={this.state.ssid}
                                        onChange={(event, data) => this.setState({ssid: data.value})}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Label className="filterPanelLabel">
                                        MAC (optional):
                                    </Label>
                                    <Input
                                        value={this.state.mac}
                                        onChange={(event, data) => this.setState({mac: data.value})}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Label className="filterPanelLabel">
                                        Authentication:
                                    </Label>
                                    <Dropdown
                                        fluid
                                        selection
                                        options={authenticationOptions}
                                        defaultValue="none"
                                        onChange={(event, data) => this.setState({authentication: data.value})}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Label className="filterPanelLabel">
                                        Username:
                                    </Label>
                                    <Input
                                        disabled={this.state.authentication !== '802.1X'}
                                        value={this.state.username}
                                        onChange={(event, data) => this.setState({username: data.value})}
                                    />
                                    <Label className="filterPanelLabel">
                                        Password:
                                    </Label>
                                    <Input
                                        disabled={((this.state.authentication !== 'PSK') && (this.state.authentication !== '802.1X'))}
                                        type="password"
                                        value={this.state.password}
                                        onChange={(event, data) => this.setState({password: data.value})}
                                    />
                                </Form.Field>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button className="filterPanel-primary-btn modal-button-padding" >
                                OK
                            </Button>
                            <Button className="filterPanel-secondary-btn modal-button-padding" onClick={() => this.handleManualModalClose()}>
                                Cancel
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/monitoring/wifiConfig.tsx